import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Marker } from "react-google-maps";
import { isItGateway } from "./utility/Utils";
import { withGoogleMap, GoogleMap } from "react-google-maps";
import { useNavigate } from "react-router-dom";

const GoogleMapExample = withGoogleMap(({ long, lat, accuracy, name, id }) => {
  let longAndLat = [];
  let [gateLocal, setGateLocal] = useState([]);
  let [counter, setCounter] = useState([]);
  let tempLat = "";
  let tempLng = "";
  let defaultPosition = null;
  let device = JSON.parse(sessionStorage.getItem("deviceList"));
  gateLocal.map((fields) => {
    defaultPosition = fields;
  });
  const navigate = useNavigate();
  useEffect(() => {
    if (long && lat) {
      setGateLocal([{ lng: long, lat: lat, name: name, id: id }]);
    } else {
      device.map((gatewayInfo) => {
        let id = gatewayInfo.id;
        if (isItGateway(gatewayInfo.kind)) {
          if (gatewayInfo.fields && gatewayInfo.fields.location) {
            tempLat = gatewayInfo.fields.location.latitude;
            tempLng = gatewayInfo.fields.location.longitude;
            longAndLat.push({
              lat: tempLat,
              lng: tempLng,
              name: JSON.stringify(gatewayInfo.imei),
              devId: id,
            });
            setGateLocal(longAndLat);
            setCounter((prev) => prev + 1);
          }
        }
      });
    }

    return () => {
      // console.log("Im unmounted");
    };
  }, []);

  return (
    <GoogleMap
      center={defaultPosition} //fix this later
      defaultZoom={accuracy || 3}
      options={{
        streetViewControl: false,
        mapTypeControl: false,
      }}
    >
      {gateLocal.map((value, id) => (
        <Marker
          key={id}
          position={value}
          animation={2}
          title={value.name}
          onClick={() => {
            let devId = value.devId;
            const data = device.find((d) => d.id === devId);
            if (devId) {
              console.log(data);
              navigate(`/DeviceInfoPage`, {
                state: {
                  data: data,
                  title: `More info for ${value.name}`,
                  fields: data.fields || {},
                },
              });
            }
          }}
        />
      ))}
    </GoogleMap>
  );
});

export const MapView = ({
  long,
  lat,
  accuracy,
  name,
  id,
  containerElement,
}) => {
  return (
    <Box>
      <GoogleMapExample
        containerElement={containerElement}
        mapElement={<div style={{ height: `100%`, width: `100%` }} />}
        long={long}
        lat={lat}
        accuracy={11}
        name={name}
        id={id}
      />
    </Box>
  );
};

export const DisplayMapView = ({ compInfo }) => {
  console.log(compInfo);
  if (compInfo.state || compInfo) {
    return (
      <Box width={"100%"} height={"100%"}>
        <MapView
          containerElement={
            <div
              style={{
                height: "35vh",
                width: compInfo.width, //width
              }}
            />
          }
          long={
            compInfo.location && compInfo.location.longitude
              ? compInfo.location.longitude
              : compInfo.state
              ? compInfo.state.fields.location.longitude
              : ""
          }
          lat={
            compInfo.location && compInfo.location.latitude
              ? compInfo.location.latitude
              : compInfo.state
              ? compInfo.state.fields.location.latitude
              : ""
          }
          accuracy={
            compInfo.location && compInfo.location.accuracy
              ? compInfo.location.accuracy
              : compInfo.state
              ? compInfo.state.fields.location.accuracy
              : ""
          }
          name={
            compInfo.state && compInfo.state.data.name
              ? compInfo.state.data.name
              : "No Name"
          }
          id={
            compInfo.state && compInfo.state.data.id
              ? compInfo.state.data.id
              : null
          }
        />
      </Box>
    );
  } else {
    return (
      <Box width={"100%"} height={"100%"}>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Location Details Not Found
        </div>
      </Box>
    );
  }
};
